module.exports = __webpack_public_path__ + "img/title-shiba.2afd1dfe.png";